import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-piston-air-compressor',
  templateUrl: './piston-air-compressor.component.html',
  styleUrls: ['./piston-air-compressor.component.scss']
})
export class PistonAirCompressorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
